import { request } from '@/utils'

export const getUseInfo = async () => {
  return await request({ method: 'POST', url: '/user/info' })
}

export const getEncodeUserId = async () => {
  return await request({ method: 'POST', url: '/user/getEncodeUserId' })
}

// 获取广告接口
export const getSlotAd = async (params: {
  goodsId?: string
  orderId?: string
  shopId?: string
  slotKey?: string
}) => {
  return await request({
    url: '/slot/get',
    method: 'GET',
    data: params,
  })
}
